import React, { useState } from "react";
import { constants } from "../assets/constants";

const CustomTag = ({ value, className = "", label, isLink = false, ...props }) => {
    const [matchedConstant, setMatchedConstant] = useState(null);

    React.useEffect(() => {
        setMatchedConstant(
            constants.all.find((e) => {
                return e.value === value;
            })
        );
    }, [value]);

    const content = matchedConstant ? (
        <span className={"c-badge " + matchedConstant.value + className} {...props}>{label ? label : matchedConstant.label}</span>
    ) : (
        <span className={"c-badge " + className} {...props}>{label ? label : value}</span>
    );

    return isLink && value ? (
        <a href={value} target="_blank" rel="noopener noreferrer">
            {content}
        </a>
    ) : (
        content
    );
};

export default CustomTag;
